export const attachIdentifierSelector = (p) => `${p.userId}-${p.value}`;
export const detachIdentifierSelector = (p) => `${p.userId}-${p.value}`;
export const setPrimaryIdentifierSelector = (p) => `${p.userId}-${p.value}`;
export const sendIdentifierTokenSelector = (p) => `${p.userId}-${p.value}`;
export const createClientCode = (p) => p.userId;
